export default __webpack_public_path__ + "static/media/image4.1de7cbb1.jpg";